import { Component, EventEmitter, Input, Output } from '@angular/core';
import OfferUtils from 'src/app/public/store/utils/OfferUtils';
import { Offer, OrderItem } from 'src/app/stores/stores';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-offer-actions',
  templateUrl: './offer-actions.component.html',
  styleUrls: ['./offer-actions.component.scss'],
})
export class OfferActionsComponent {
  @Input() itemAddedToCart: EventEmitter<{
    offerId: number;
    categoryId: number;
    inStock: boolean;
    isDirectlyOrderable: boolean;
    isExpandable: boolean;
    isOrderable: boolean;
    basketEnabled: boolean;
    orderItem?: OrderItem;
  }>;
  @Input() decreaseItemQty: EventEmitter<OrderItem>;
  @Input() currentCartStatus: string;
  @Input() offer: Offer;
  @Input() cartItems: OrderItem[];
  @Input() basketEnabled = true;
  @Input() size: 'small' | 'regular' = 'regular';
  @Input() orderingEnabled = true;
  @Input() isAdminOrderCaptureUpdate = false;
  @Input() orderCaptureEnabled = true;

  @Output() productDetailsViewed = new EventEmitter<{
    offerId: any;
    categoryId: any;
    inStock: any;
    isExpandable: any;
    isOrderable: any;
    basketEnabled: any;
  }>();

  constructor(private sanitizer: DomSanitizer) {}

  onOneClickAddToCart(event) {
    event.stopPropagation();
    const {
      offerId,
      categoryId,
      inStock,
      isDirectlyOrderable,
      isExpandable,
      isOrderable,
    } = this.offer;
    this.itemAddedToCart.emit({
      offerId,
      categoryId,
      inStock,
      isDirectlyOrderable,
      isExpandable,
      isOrderable,
      basketEnabled: this.basketEnabled,
      orderItem: this.cartItems[0],
    });
  }

  onDecreaseItemQty(event) {
    event.stopPropagation();
    this.decreaseItemQty?.emit(this.cartItems[0]);
  }

  getQuantity() {
    return this.cartItems?.reduce((acc, item) => acc + item.quantity, 0) || 0;
  }

  showPlusButton(): boolean {
    return OfferUtils.showPlusButton(
      this.offer,
      this.basketEnabled,
      this.orderingEnabled,
      this.isAdminOrderCaptureUpdate,
      this.orderCaptureEnabled,
    );
  }

  onInfoIconClick(event) {
    event.stopPropagation();

    const { offerId, categoryId, inStock, isExpandable, isOrderable } =
      this.offer;

    // In admin order capture mode, preserve original behavior for cart operations
    if (this.isAdminOrderCaptureUpdate && this.orderCaptureEnabled) {
      this.itemAddedToCart.emit({
        offerId,
        categoryId,
        inStock,
        isDirectlyOrderable: false,
        isExpandable,
        isOrderable,
        basketEnabled: this.basketEnabled,
      });
    } else {
      // For regular customer UI or admin with order capture disabled, navigate to product details
      this.navigateToProductDetails(
        offerId,
        categoryId,
        isExpandable,
        isOrderable,
      );
    }
  }

  private navigateToProductDetails(
    offerId: any,
    categoryId: any,
    isExpandable: any,
    isOrderable: any,
  ) {
    this.productDetailsViewed.emit({
      offerId,
      categoryId,
      inStock: this.offer.inStock, // Use actual inStock value from the offer
      isExpandable,
      isOrderable,
      basketEnabled: this.basketEnabled,
    });
  }

  shouldShowInfoIcon(): boolean {
    return this.offer.isExpandable && !this.showPlusButton();
  }
  getBackgroundImage(url: any) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }
    return '';
  }
  isIncreaseQtyDisabled() {
    return this.offer?.itemType == 'Reservable';
  }
}
